"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBucketEncryptionOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=DeleteBucketEncryptionOutput.js.map